import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Img from 'gatsby-image';

const Feature = ({ feature }) => (
  <div className="feature">
    {feature.featureTypeOfFeature === 'embed' ? (
      <>
        {feature.featureEmbed ? (
          <div className="embed">
            <iframe
              title="embedded player"
              src={feature.featureEmbed}
              allowtransparency="true"
              allow="encrypted-media"
            />
          </div>
        ) : (
          ''
        )}
      </>
    ) : (
      ''
    )}
    {feature.featureTypeOfFeature === 'image' ? (
      <>
        {feature.featureImage ? (
          <Img
            className="feature-image"
            fluid={feature.featureImage.localFile.childrenImageSharp[0].fluid}
            alt="Feature Image"
          />
        ) : (
          ''
        )}
      </>
    ) : (
      ''
    )}
    {feature.featureDescription ? (
      <div className="copy">{parse(feature.featureDescription)}</div>
    ) : (
      ''
    )}
  </div>
);

Feature.propTypes = {
  feature: PropTypes.object,
};
Feature.defaultProps = {
  feature: {},
};
export default Feature;
